export default {"src":"/_next/static/media/factsheet-table-small.def9299d.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};